module.exports = new __parcel__URL__("cornershop-ipad.448dc465.png").toString();